<template>
  <b-modal
    :no-close-on-backdrop="true"
    :id="id"
    size="md"
    body-class="bg-white"
    cancel-title="Cancel"
    cancel-variant="light"
    :ok-title-html="submitted==true?loaderIcon+'Yes':'Yes'"
    @hidden="$emit('setMultipleAddedRef', {
        close : true
      })"
    @ok="handledelete"
    title="Delete"
    ref="dropdowndelete"
    :ok-disabled="submitted"
  >
    <p>{{ content }}</p>
  </b-modal>
</template>

<script>
import { notificationMixin } from "@/mixins/notification";
import { mapState } from "vuex";
export default {
  mixins: [notificationMixin],
  props: ["content", "module", "method", "value", "types", "id"],
  data() {
    return {
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      submitted: false,
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center"
    };
  },
  methods: {
    handledelete() {
      this.submitted = true;
      this.$store
        .dispatch(
          this.module + "/" + this.method,
          JSON.stringify({
            id: this.value,
            type: this.types
          })
        )
        .then(() => {
          this.submitted = false;
          window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: this.message,
            type: this.code == 200 ? "success" : "danger",
            showCloseButton: true
          });

          this.$emit("setDropdownDelete", this.code);

          this.$refs.dropdowndelete.hide();
        });
      this.submited = false;
    }
  },
  created() {
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
  },
  computed: {
    ...mapState({
      code: state => state.general.code,
      message: state => state.general.message,
      message_type: state => state.general.message_type
    })
  }
};
</script>

<style>
</style>
